import * as React from 'react';
import { observer } from 'mobx-react';
import * as JsBarcode from 'jsbarcode';

export interface IBarcodeProps {
    data: string;
    options?: JsBarcode.Options;
}

export const Barcode = observer(({ data, options }: IBarcodeProps) => {
    const ref = React.createRef<HTMLCanvasElement>();
    React.useEffect(() => {
        if (ref.current && data) {
            JsBarcode(`#${ref.current.id}`, data, options);
        }
    }, [ref, data]);

    return <>{data && <canvas ref={ref} id="user-identifier" />}</>;
});
